export default __webpack_public_path__ + "static/media/order.f9d1478c.svg";